import { AgeFactor } from './age-factor';

export class Person {
    name: string;
    ageFactor: AgeFactor;
}